/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/arrows-move-2";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "ArrowsMove2";
export { I as ArrowsMove2 };
